// extracted by mini-css-extract-plugin
export default {"wrapper":"ZB-z","viewport":"_B-z","container":"aC-z","slide":"bC-z"};